<div id="health" class="registration container">
    <form #healthForm="ngForm" [ngClass]="{'form-complete': healthForm.valid }" (ngSubmit)="forward(healthForm)" novalidate autocomplete="off" appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
      <h1>{{ 'copy.label.AGREEMENT.label' | copy | async }}</h1>
      <section class="card">
        <div class="card-header">
          <div class="card-title">
            {{ 'copy.label.AGREEMENT.header' | copy | async }}
          </div>
        </div>
        <article>
              <div class="agreeCheckbox mb-2" *ngIf="!isRegComplete">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="termsAndConditions" [(ngModel)]="enrollment.AgreedToTermsAndConditions" #termsAndConditions="ngModel" required></mat-checkbox>
                  <label class="required pr-label">
                    I agree to the Maritz <b><a style="color:#007bff" (click)="openModal('termsOfUse', 'About This Site', 'Close');">Terms of Use</a></b> and
                    the <b><a style="color:#007bff" (click)="openModal('ResponsibilityStatement', 'Responsibility Statement', 'Close');">Responsibility Statement</a></b>.</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="termsAndConditions" isRequired=true></app-validation></small>
                </div>
              </div>
              <div class="agreeCheckbox mb-2" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="cancelpolicy" [(ngModel)]="enrollment.$mtccancelpolicy" #cancelpolicy="ngModel" required></mat-checkbox>
                  <label class="required pr-label">
                    By clicking here, I acknowledge and understand the <b><a style="color:#007bff" tabindex="0" (click)="openModal('CancelPolicy', 'Cancellation Policy', 'Close')" (keydown.enter)="openModal('CancelPolicy', 'Cancellation Policy', 'Close')">Cancellation Policy</a></b> for Focus 2025.</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="cancelpolicy" isRequired=true></app-validation></small>
                </div>
              </div>
              <div class="agreeCheckbox mb-2" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor') && attendee.PAXTypeNo !== 50">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="travelpolicy" [(ngModel)]="enrollment.$mtctravelpolicy" #travelpolicy="ngModel" required></mat-checkbox>
                  <label class="required pr-label">
                    By clicking here, I acknowledge and understand the 1099 policies associated with Focus 2025 listed in the <b><a style="color:#007bff" href="https://assets.prod.travelhq.com/sitefiles/program/111650/asset/2025TravelPolicies.pdf" target="_blank"> 2025 Travel Policies</a></b>.</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="travelpolicy" isRequired=true></app-validation></small>
                </div>
              </div>

              <div class="agreeCheckbox mb-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="privacy" [(ngModel)]="enrollment.PrivacyPolicy" #privacy="ngModel"></mat-checkbox>
                  <label class="pr-label">
                    I agree to the LPL Financial <b><a style="color:#007bff" href="https://www.lpl.com/disclosures/privacy-security.html" target="_blank">Privacy Policy</a></b> I understand that Maritz may collect and process my personal information on behalf of LPL Financial.</label>
                </div>
                <!-- <div class="w-100">
                  <small class="text-danger"><app-validation [object]="privacy" isRequired=true></app-validation></small>
                </div> -->
              </div>


              <div class="agreeCheckbox mb-2">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="conduct" [(ngModel)]="enrollment.$mtccodeofconduct" #conduct="ngModel" required></mat-checkbox>
                  <label class="required pr-label">
                    By clicking here, I acknowledge that I have read the <b><a style="color:#007bff" href="https://assets.prod.travelhq.com/sitefiles/program/111650/asset/ConferenceCodeofConduct.pdf" target="_blank">Conference Code of Conduct</a></b> and agree to the terms and conditions outlined in the policy.</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="conduct" isRequired=true></app-validation></small>
                </div>
              </div>

              <!-- <strong>Assumption of Risk</strong>
              <div class="agreeCheckbox">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="assumerisk" [(ngModel)]="enrollment.$mtcassumptionrisk" #assumerisk="ngModel" required></mat-checkbox>
                  <label class="required">
                    Given the inherent risks associated with COVID-19, I understand LPL cannot prevent me or my family from becoming exposed to, contracting, or spreading COVID-19 while traveling to and from and attending the conference. By choosing to attend the conference in person, I choose to knowingly accept those risks.</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="assumerisk" isRequired=true></app-validation></small>
                </div>
              </div> -->

              <strong class="mb-2">Personal Accountability Commitment</strong>
              <div class="agreeCheckboxPac agreeCheckbox pr-4">
                <div class="checkboxFlexContainer">
                  <mat-checkbox name="pac" [(ngModel)]="enrollment.$mtcpacack" #pac="ngModel" required></mat-checkbox>
                  <label class="required pr-label">
                    LPL Financial believes that its upcoming conference will provide valuable information. By registering, you agree not to travel to or attend the conference if you are feeling unwell or sick.</label>
                </div>
                <div class="w-100">
                  <small class="text-danger"><app-validation [object]="pac" isRequired=true></app-validation></small>
                </div>
              </div>
  
            </article>
          </section>
  
      <div class="button_group d-flex">
        <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
          <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
          {{ 'copy.label.GLOBAL.goback' | copy | async }}
        </button>
        <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
          {{ 'copy.label.GLOBAL.continue' | copy | async }}
          <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
        </button>
        <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
          <i class="fas fa-spinner fa-spin"></i>
        </button>
      </div>
    </form>
  </div>
  
